import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { home } from 'src/app/core/constants/routes';
import { UserDataService } from 'src/app/core/services/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class PendingApprovalGuard {
  constructor(
    private userDataService: UserDataService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isPendingApproval = this.userDataService.user?.pendingApprovalAddons?.includes('shop') ?? false;

    if (isPendingApproval) {
      return true;
    }

    this.router.navigateByUrl(home);
    return false;
  }
}
